import { ContextStore } from 'bernie-plugin-mobx';

/**
 * Returns  Duaid and TraceId  to be logged for requests
 */
export const getTrackingInfoForLogging = (context: ContextStore): string => {
  const duaid = context && context.deviceId;
  const traceId = undefined; // bernie context no longer provides this

  return ` DUAID=${duaid} , TraceID=${traceId}`;
};
